import { CountryEnum } from "./Country";
import { Manager } from "./Manager";

export enum AuditLogActionTypeEnum {
  Login = "Login",
  Delete = "Delete",
  Update = "Update",
  Create = "Create",
}

export enum AuditLogEntityEnum {
  Manager = "Manager",
  BillingWalletAddress = "BillingWalletAddress",
}

export enum AuditLogStatusEnum {
  Success = "Success",
  Failed = "Failed",
}

export type AuditLog = {
  id: string;
  createdAt: string | null;

  managerId: string;
  manager?: Manager;

  actionType: AuditLogActionTypeEnum;
  entity: AuditLogEntityEnum;
  path: string;
  identifier: string;
  ipAddress: string;
  reqStatus: AuditLogStatusEnum;
  oldValue: any;
  newValue: any;
  country: CountryEnum;
  fields: any;
  description: string | null;
  extraData?: Record<string, any>;
};
